module.exports = __webpack_public_path__ + "img/rozliczono.4dc89936.svg";